const getWorksiteId = () => {
  console.log(window.location.pathname);

  //TODO: we're returning now only 1

  return 1;
};

export default getWorksiteId;
